import { useQuery } from 'react-query';
import api, { QueryConfig } from '@shared/api';
import { OrganizationMember } from '@shared/types';

interface OrganizationMemberApi extends OrganizationMember {
  userName: string;
}

const mapUsers = (users: OrganizationMemberApi[]) =>
  users
    .filter(user => !user.deleted)
    .map(user => ({
      username: user.userName,
      firstName: user.firstName,
      lastName: user.lastName,
      role: user.role,
      avatar: user.avatar,
      email: user.email,
      joinedAt: user.joinedAt,
      lastActivityAt: user.lastActivityAt,
      pending: user.pending
    }));

const getOrganizationMembers = async (
  organizationId: string,
  signal?: AbortSignal
) => {
  const { data = [] } = await api.get(
    `organizations/${organizationId}/members`,
    { signal }
  );
  return mapUsers(data);
};
const useOrganizationUsers = (
  organizationId: string,
  config?: QueryConfig<OrganizationMember[]>
) =>
  useQuery(
    // Temporary suppression due to type mismatch of 'organizationId'.
    // Type 'string' is not assignable to type 'Record '.
    // Needs refactoring, but addressing it now would require extensive changes.

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    /* @ts-ignore */
    ['organizations', organizationId, 'members'],
    ({ signal }) => getOrganizationMembers(organizationId, signal),
    {
      ...config,
      enabled: !!organizationId
    }
  );

export default useOrganizationUsers;
